// extracted by css-extract-rspack-plugin
export default {"lazyloadFilterContainer":"FiltersBadgeLazyLoaderStyles-module__lazyloadFilterContainer"};